/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
import './confirm.user.tpl.html';

angular
  .module('restore.confirm', ['ngSanitize'])
  /**
   * Controller for the restore.confirm template.
   */
  .controller('RestoreConfirmCtrl', function ($scope, sObjectUtils, wizardUtils, RestoreProgress, TYPES, $filter) {
    $scope.headerValues = {
      field: 'label'
    };

    $scope.reverse = false;
    $scope.sortBy = $scope.headerValues.field;
    $scope.items = [];
    $scope.attachments = [];
    // enables the tooltip on the attachment icon hover.
    $scope.showAttachmentInfo = true;

    // Iterate though the current diff to find the selected object for restore confirmation.
    _.each(sObjectUtils.currentDiff.diffs, function (item) {
      if (sObjectUtils.selectedItems.indexOf(item.name) !== -1) {
        $scope.items.push(item);
      }
    });

    // Iterate though the current diff attachments to find the selected attachments.
    _.each(sObjectUtils.currentDiff.attachments, function (attachment) {
      if (
        _.findIndex(
          sObjectUtils.selectedAttachments,
          (selected) => selected.id === attachment.id && selected.batchId === attachment.batchId
        ) !== -1
      ) {
        $scope.attachments.push(attachment);
      }
    });

    $scope.name = sObjectUtils.currentDiff.name;

    // Set the type of object for this restore
    $scope.type = sObjectUtils.objectName;
    // Different CSS classes used to display the appropriate icon in the view
    $scope.TYPES = TYPES;

    /**
     * Returns boolean whether to show up or down arrow for header.
     * @param header - The header value.
     * @returns {string} The class to use..
     */
    $scope.isSelectedHeader = function (header) {
      var headerClass = '';
      if ($scope.sortBy === header) {
        if ($scope.reverse) {
          headerClass = 'sbsf-log-header-desc sca-icon-down-black';
        } else {
          headerClass = 'sbsf-log-header-asc sca-icon-down-black';
        }
      }
      return headerClass;
    };

    /**
     * Sets the sort parameter to the header selected.
     * @param {String} header - The header value and property to sort by.
     */
    $scope.selectHeader = function (header) {
      $scope.reverse = !$scope.reverse;
      $scope.sortBy = header;
    };

    /**
     * Provides the previous version header text.
     *
     * @returns {String} - The previous version header text.
     */
    $scope.getPreviousVersionMsg = function () {
      return $filter('i18n')(
        'RESTORE_VERSION_DATE',
        moment(sObjectUtils.currentVersion.lastModified).format($filter('i18n')('M_D_Y'))
      );
    };

    /**
     * Provides the current version header text.
     *
     * @returns {String} - The current version header text.
     */
    $scope.getCurrentVersionMsg = function () {
      return $filter('i18n')('CURRENT_VERSION');
    };

    /**
     * Provides the message for specifying the number of differences.
     *
     * @returns {String} - The differences text.
     */
    $scope.getDifferencesText = function () {
      var count = $scope.items.length + $scope.attachments.length,
        changeStr = $filter('pluralize')(count, 'ONE_CHANGE', 'CHANGES');

      return $filter('i18n')('CHANGES_FROM', [
        changeStr,
        moment(sObjectUtils.currentVersion.lastModified).format($filter('i18n')('M_D_Y_H_M'))
      ]);
    };

    /**
     * Provides the header string for the attachments section.
     *
     * @returns {string} - The header string for attachments.
     */
    $scope.getAttachmentHeader = function () {
      return $filter('i18n')('RESTORE_ATTACHMENTS');
    };

    /**
     * Handler for the next button.
     */
    wizardUtils.next = function () {
      sObjectUtils.submitRestore().then(function (result) {
        if (result) {
          RestoreProgress.startPolling();
        }
      });
    };
  });
